/* eslint-disable consistent-return */
import { enqueueSnackbar } from "notistack";
import axiosInstance from "src/utils/axios";
import localStorageAvailable from "src/utils/localStorageAvailable";


const getEventsByHandle = async (user, handle, logout, vendor) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `/service/events_service/v1/events/event/handle/${handle}`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
    params: {
      vendor
    }
  };

  try {
    const response = await axiosInstance.request(config);
    return response;
  } catch (error) {
    if (error?.data === "Verification timeout") {
      return;
    }
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    enqueueSnackbar(error?.data?.message || error?.data, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default getEventsByHandle;
